import { render, staticRenderFns } from "./TechnicalStyleView.vue?vue&type=template&id=05b34fe8&scoped=true"
import script from "./TechnicalStyleView.vue?vue&type=script&lang=js"
export * from "./TechnicalStyleView.vue?vue&type=script&lang=js"
import style0 from "./TechnicalStyleView.vue?vue&type=style&index=0&id=05b34fe8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b34fe8",
  null
  
)

export default component.exports